import { APP_ROUTES } from "const";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import { useMemo } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export function useUrlQuery<T extends object>() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const params = useMemo(() => {
    return Object.fromEntries(new URLSearchParams(searchParams));
  }, [searchParams]) as T;

  const setter = useMemo(() => {
    return (cb: (val: T) => T, path?: APP_ROUTES | string) => {
      const newValues = pickBy(cb(params), identity);
      if (!path) {
        //@ts-ignore
        setSearchParams(newValues);
      } else {
        const search = Object.keys(newValues)
          .map((key) => key + "=" + newValues[key])
          .join("&");
        navigate({ pathname: path, search }); //
      }
    };
  }, [navigate, params, setSearchParams]);

  return [params, setter, searchParams.toString()] as [
    T,
    typeof setter,
    string
  ];
}
